$(document).ready(function() {
  $(".list--load-more").attr('data-controller', 'show-more');
  $(".list--load-more li").attr('data-target', 'show-more.item');

  $(".list--load-more").each(function() {
    var listCount = $(this).children().length - 3;
    $(this).append(`<a class="show-more-button" href="#" data-action="click->show-more#trigger" data-target="show-more.button"><span class="show-more-button__count">+${listCount}</span>Zobrazit další<span class="show-more-button__arrow"></span></a>`);
  });

  $(".text-load-more").attr('data-controller', 'show-more').attr('data-limit-shown', false);
  $(".text-load-more__hidden").attr('data-target', 'show-more.item');

  $(".text-load-more").each(function() {
    $(this).append(`<a class="text-load-more__button" href="#" data-action="click->show-more#trigger" data-target="show-more.button">Zobrazit více<span class="text-load-more__arrow"></span></a>`);
  });
});
